export default "__VITE_ASSET__a653fb9c__"